module.exports = __webpack_public_path__ + "img/generated-1772432199400.5ecb29a5.png";